import {
  IHospitalizedHisInformationItemSelectBehavior, IHospitalizedHisInformationItemSelectBehaviorSpecifiable,
} from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean } from "../../../beans";
import { IObjectBeanHisItemSelectable } from "../../../beans/objects";
import { ObjectReferableFeatureTranslator } from "./ObjectReferableFeatureTranslator";
import { LinkedPageObjectTranslator } from "./LinkedPageObjectTranslator";

export class HospitalizedHisInformationItemSelectBehaviorTranslator {
  from(bean: IXElementContentsObjectBean & IObjectBeanHisItemSelectable): IHospitalizedHisInformationItemSelectBehavior {
    return {
      shouldSelectHospitalizedOnly: (bean["@admission"] === "1"),
      baseDateReferBehavior: this.baseDateReferBehavior.from(bean),
    };
  }

  to(object: IHospitalizedHisInformationItemSelectBehaviorSpecifiable) {
    return {
      admission: object.hospitalizedHisInformationItemSelectBehavior.shouldSelectHospitalizedOnly
        ? "1"
        : undefined,
      relationalBaseDate: this.baseDateReferBehavior.to(object.hospitalizedHisInformationItemSelectBehavior.baseDateReferBehavior),
    };
  }

  private readonly baseDateReferBehavior = new ObjectReferableFeatureTranslator("base-date", new LinkedPageObjectTranslator());
}
